module.exports = __webpack_public_path__ + "static/media/ic-search-big.dc5b5503.svg";